import { motion } from 'framer-motion';

export const MotionDiv = ({ delay, children }) => {
	const delayConfig = delay && {
		delay
	};
	return (
		<motion.div
			initial={{ opacity: 0, translateY: 550 }}
			animate={{ opacity: 1, translateY: 0 }}
			transition={{ type: 'spring', stiffness: 150, damping: 30, ...delayConfig }}>
			{children}
		</motion.div>
	);
};
